<template>
  <v-container fluid>
    <v-tabs color="secondary">
      <v-tab>Users</v-tab>
      <v-tab-item>
        <User></User>
      </v-tab-item>
      <v-tab>Concerns</v-tab>
      <v-tab-item>
        <LuConcern></LuConcern>
      </v-tab-item>
      <v-tab>Priorities</v-tab>
      <v-tab-item>
        <LuPriority></LuPriority>
      </v-tab-item>
      <v-tab>Agencies</v-tab>
      <v-tab-item>
        <LuAgency></LuAgency>
      </v-tab-item>
      <v-tab>Sessions</v-tab>
      <v-tab-item>
        <LuSession></LuSession>
      </v-tab-item>
      <!-- <v-tab>Bill Tracker</v-tab>
      <v-tab-item>
        <TrackedBill></TrackedBill>
      </v-tab-item> -->
      <!-- <v-tab>Users2</v-tab>
        <v-tab-item>
          <Users></Users>
        </v-tab-item>-->
    </v-tabs>
  </v-container>
</template>
<script>
import LuPriority from '@components/admin/LuPriorityGrid'
import LuAgency from '@components/admin/LuAgencyGrid'
import LuSession from '@components/admin/LuSessionGrid'
import LuConcern from '@components/admin/LuConcernGrid'
import TrackedBill from '@components/admin/TrackedBillGrid'
import User from '@components/search/UserGrid'
export default {
  page: {
    title: 'Administration',
  },
  //model: {
  //	prop: ''
  //},
  props: {},
  components: { LuPriority, LuConcern, TrackedBill, User, LuAgency, LuSession },
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {},
  watch: {},
}
</script>
<style scoped></style>
